
import { createContext } from "react";

export const authContext = createContext({
  authenticated: false, // to check if authenticated or not
  user: {}, // store all the user details
  roles: {}, // store all the user roles
  accessToken: "", // accessToken of user for Auth0
  jwtlogin: (token) => {}, // to start the uf login process
  login: (username, password) => {}, // to start the login process
  logout: () => {}, // logout the user
  updateIsTrainee: () => {}, // update if the user isTrainee status
  updateUser:  async (username) => {} // refresh user info 
});

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;
